export default __webpack_public_path__ + "static/media/car5.4060581d.jpg";